import { gql } from "@apollo/client";

export const PROCESAR_DOCUMENTOS_SAP = gql`
    mutation procesarDocumentosSap($documentos: [DocumentoSapProcesarModelInput!]! ){
        procesarDocumentosSap(documentos: $documentos) {
            numeroDocumento
        }
    }
`;